<app-article-content-container [pageData]="pageData"></app-article-content-container>
<app-re-article [pageData]="pageData"></app-re-article>
<app-common-getstarted
  [getStartedData]="getStartedData"
></app-common-getstarted>
